import { render, staticRenderFns } from "./ConversionesComponent.vue?vue&type=template&id=6bf135f0&"
import script from "./ConversionesComponent.vue?vue&type=script&lang=js&"
export * from "./ConversionesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports